import React from 'react';
import { useTranslation } from 'react-i18next';

const Logo = ({ light = false }) => {
  const { t } = useTranslation();
  const primary = light ? '#ffffff' : '#173f35';
  const accent = '#27ae60';

  return (
    <span className="brand-logo" aria-label="Tout Propre">
      <svg
        className="brand-logo-mark"
        viewBox="0 0 64 64"
        role="img"
        aria-hidden="true"
      >
        <path
          d="M8 31 32 11l24 20v22a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V31Z"
          fill="none"
          stroke={primary}
          strokeWidth="5"
          strokeLinejoin="round"
        />
        <path
          d="m22 40 7 7 14-16"
          fill="none"
          stroke={accent}
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M49 5v9M44.5 9.5h9" stroke={accent} strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span className="brand-logo-copy">
        <span className="brand-logo-text" style={{ color: primary }}>
          Tout <strong>Propre</strong>
        </span>
        <span className="brand-logo-tagline" style={{ color: primary }}>
          {t('logo.tagline')}
        </span>
      </span>
    </span>
  );
};

export default Logo;
